import {APIService} from "../../common/APIService";
import {NotificationLog} from "../../dto/NotificationLog";

export class NotificationLogService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`notification-logs`)
    return json.data.map(item => NotificationLog.fromJson(item))
  }

  public async delete(notificationLogId: string) {
    await this.deleteJson(`notification-logs/${notificationLogId}`)
  }
}